import { useTheme } from "@mui/material";

export const useResponsiveDatePickerStyle = () => {
    const theme = useTheme();

    return {
        button: {
            "&:hover": {
                backgroundColor: "transparent",
            },
        },
        iconBox: {
            display: "inline-flex",
            alignItems: "center",
            "& svg": {
                width: "0.75em",
                height: "0.75em",
            },
            "& g": {
                fill: theme.palette.primary.main,
            },
            "& path": {
                fill: theme.palette.primary.main,
            },
        },
        calendarPopper: {
            "& .MuiPaper-root": {
                border: `1px solid ${theme.palette.secondary.main}`,
            },
            "& .MuiPickersCalendarHeader-root": {
                color: theme.palette.secondary.main,
                "& .MuiPickersCalendarHeader-labelContainer": {
                    color: theme.palette.secondary.main,
                },
                "& .MuiPickersCalendarHeader-label": {
                    color: theme.palette.secondary.main,
                    fontWeight: theme.typography.fontWeightRegular,
                },
                "& .MuiPickersCalendarHeader-switchViewButton": {
                    color: theme.palette.secondary.main,
                    "& svg": {
                        fill: theme.palette.secondary.main,
                    },
                },
            },
            "& .MuiPickersArrowSwitcher-root": {
                "& button svg": {
                    fill: theme.palette.primary.main,
                },
            },
            "& .MuiDayPicker-weekDayLabel": {
                fill: theme.palette.secondary.main,
                color: theme.palette.secondary.main,
            },
            "& .MuiTypography-root.MuiDayPicker-weekDayLabel": {
                fill: theme.palette.secondary.main,
                color: theme.palette.secondary.main,
            },
            "& .MuiPickersDay-root": {
                color: theme.palette.secondary.main,
                "&.Mui-selected": {
                    backgroundColor: theme.palette.primary.main,
                    color: theme.palette.primary.contrastText,
                },
                "&.MuiPickersDay-today": {
                    border: `1px solid ${theme.palette.secondary.main}`,
                },
            },
        },
    };
};
